import axios from 'axios';
import { BaseURLs } from './Consts'
const baseUrl = process.env.NODE_ENV === "development"
  ? BaseURLs.debug.url
  : BaseURLs.prod.url;

//console.log("Base URL:", baseUrl);

const http = axios.create({
    baseURL: baseUrl,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'x-api-key': '',
        "Access-Control-Allow-Origin": "*",
    }
});

// Definindo o interceptor padrão para todas as requisições

http.interceptors.request.use(async (config: any) => {
    const { headers } = config;
    const token = localStorage.getItem("tokenKey");
    headers['x-api-key'] = token ? token : '0ca95abd854eebdfb822be11bd1470dd3e48e991d886f00e9ae1a31d23135db8d9340eec57c7e4f5a79ca6e5e2ee6115827d5f512a65170ed99ab917ee7ef7e0'; // Pegar este valor do locastorage/cookie/redux
     //headers['x-api-key'] = '0ca95abd854eebdfb822be11bd1470dd3e48e991d886f00e9ae1a31d23135db8d9340eec57c7e4f5a79ca6e5e2ee6115827d5f512a65170ed99ab917ee7ef7e0'; // Pegar este valor do locastorage/cookie/redux
    return config;
});

export { http };